import React from 'react';
import { Text } from '@amzn/storm-ui-v3';
import { ICellRendererParams } from '@ag-grid-community/core';
import { useTranslateMapItem } from '@urc-ui/hooks/translate-map';
import { TIME_UNIT_TRANSLATION_MAP } from '@urc-ui/utils/subscription-utils';
import { StyledCellWrapper } from '@urc-ui/components/styles';

export function TimeUnitCell(props: ICellRendererParams) {
  const timeUnit = (props.value as string)?.trim().toUpperCase() || '';
  const text = useTranslateMapItem(TIME_UNIT_TRANSLATION_MAP, timeUnit);
  return (
    <StyledCellWrapper>
      <Text fontSize='small'>{text}</Text>
    </StyledCellWrapper>
  );
}
